import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { RenderJob } from '../render-flow.model';
import { RenderFlowService } from '../render-flow.service';
import { RENDER_OFFER_BENEFITS, RENDER_PRICE_USD } from '../render.data';

// A sample's card where a model of your own has its order card (step 2) or its platforms (step 3):
// what your own model gets and for how much, and the way to upload it. A sample is shown, never
// sold, and its videos are not handed over — they are not the user's model (owner, 2026-10-23).
// Step 2's card also leads to the sample's finished videos (`offerVideos`); step 3's ends on the
// button (owner, 2026-10-23: no "Its preview is free." under it, nor on step 2's subtitle). Put on the card's own
// element (`<aside class="order-card" app-render-sample-card>`), so the page's card styles hold.
@Component({
  // An attribute: the card's flex layout needs the card's own element as the host.
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-render-sample-card]',
  templateUrl: './render-sample-card.component.html',
})
export class RenderSampleCardComponent {
  @Input() public job?: RenderJob;
  @Input() public offerVideos = false;

  public readonly price = RENDER_PRICE_USD;
  public readonly benefits = RENDER_OFFER_BENEFITS;

  constructor(
    private readonly router: Router,
    private readonly flow: RenderFlowService,
  ) {}

  public onUpload(): void {
    this.router.navigateByUrl('/render/upload');
  }

  // The shell follows the job to its downloads page.
  public onVideos(): void {
    if (this.job) {
      this.flow.openSampleVideos(this.job.modelId);
    }
  }
}
